window.addEventListener('DOMContentLoaded', function() {
    $('.t4s-main-article-page h2').each(function (index, value) {
        $(this).attr('id', 'untitled_' + index)
        $('ul#itemNav').append('<li id="li' + index + '">' + $(this).text() + '</li>')
    })
    $('ul#itemNav li').on('click', function () {
        var ind = $(this).index();
        $('html,body').animate({
            scrollTop: $('.t4s-main-article-page h2#untitled_' + ind).offset().top - 120
        }, 100);
    });

    if ($(window).width() > 640) {
        $(window)['on']('scroll', function () {
          $('.t4s-main-article-page h2').each(function (index, value) {
            var _target = parseInt($(this).offset().top - $(window).scrollTop() - 120);
            var _i = $(this).attr('id');
            var index = _i.split("_")[1];
            if (_target <= 0) {
              $('ul#itemNav li').removeClass('on');
              $('ul#itemNav li#li' + index).addClass('on');
            }
          });
        });
      }
})